<template>
    <div>
        <chat-header
          :title="config.websiteName"
          :avatar-url="config.avatarUrl"
          :show-popout-button="config.showPopoutButton"
        />
        <div class="offline-message-container">
            <span>{{ offlineMessage }}</span>
        </div>
        
    </div>
</template>

<script>
import {OFFLINE_MESSAGE} from '../helpers/constants'
import ChatHeader from './ChatHeader.vue';
export default {
    name: 'OfflineComponent',
    components: {
        ChatHeader,
    },
    props:{
        config:{
            type: Object,
            default:()=>{}
        }
    },
    data(){
        return {
            offlineMessage : OFFLINE_MESSAGE
        }  
    }    
}
</script>

<style scoped>
.offline-message-container{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    min-height: 20rem;
    font-size: 1.5em;
    font-weight: 500;
}
</style>